const analyticService = {
  sendEvent: (event, payload = {}) => {
    payload.event = event;
    if (window.dataLayer) {
      window.dataLayer.push(payload);
    } else {
      console.log('Trigger analytic event without sending to Analytics (Most likely DEV ENV)', payload);
    }
  }
};

export default analyticService;